function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { Children } from "react";
import PropTypes from "prop-types";
import Accordion from "./Accordion";
import Container from "./Container";
import Flex from "./Flex";
import Icon from "./Icon";
import Link from "./Link";
import Stack from "./Stack";
import Text from "./Text";
import useBreakpoint from "../hooks/useBreakpoint";
import useTheme from "../hooks/useTheme";
import Logo from "./Logo";
import useFooterLinks, { FooterLinksProvider } from "../hooks/useFooterLinks";
import { compareBreakpoints } from "../utils/css";
import { mergeProps } from "../utils/component";
import { jsx as ___EmotionJSX } from "@emotion/core";

function HeaderLogo(_ref) {
  var name = _ref.name,
      testId = _ref.testId;
  return ___EmotionJSX(Container, {
    height: "56",
    "height-lg": "80",
    testId: testId
  }, ___EmotionJSX(Flex, {
    height: "100%",
    placeItems: "left center"
  }, ___EmotionJSX(Logo, {
    name: name,
    color: "white",
    height: "36",
    "height-xs": "40",
    "height-lg": "48",
    maxWidth: "120",
    "maxWidth-xs": "none"
  })));
}

HeaderLogo.propTypes = {
  name: PropTypes.oneOf(Logo.NAMES).isRequired,
  testId: PropTypes.string
};

function HeaderSocial(_ref2) {
  var children = _ref2.children,
      testId = _ref2.testId;
  return ___EmotionJSX(Container, {
    height: "56",
    width: "100%",
    "width-sm": "auto",
    "margin-sm": "0 0 0 auto",
    testId: testId
  }, ___EmotionJSX(Flex, {
    height: "100%",
    placeItems: "left center"
  }, ___EmotionJSX(Text, {
    margin: "0",
    "margin-sm": "0 4 0 0"
  }, ___EmotionJSX("strong", null, "Connect with us")), ___EmotionJSX(Stack, {
    direction: "horizontal",
    gap: "3",
    margin: "0 0 0 auto",
    "margin-sm": "0"
  }, children)));
}

HeaderSocial.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function SocialFacebook(_ref3) {
  var href = _ref3.href,
      title = _ref3.title,
      onClick = _ref3.onClick,
      testId = _ref3.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    onClick: onClick,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "facebook",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialFacebook.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  testId: PropTypes.string
};

function SocialYouTube(_ref4) {
  var href = _ref4.href,
      title = _ref4.title,
      onClick = _ref4.onClick,
      testId = _ref4.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    onClick: onClick,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "youtube",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialYouTube.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  testId: PropTypes.string
};

function SocialTwitter(_ref5) {
  var href = _ref5.href,
      title = _ref5.title,
      onClick = _ref5.onClick,
      testId = _ref5.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    onClick: onClick,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "twitter",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialTwitter.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  testId: PropTypes.string
};

function SocialInstagram(_ref6) {
  var href = _ref6.href,
      title = _ref6.title,
      onClick = _ref6.onClick,
      testId = _ref6.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    onClick: onClick,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "instagram",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialInstagram.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  testId: PropTypes.string
};

function SocialLinkedIn(_ref7) {
  var href = _ref7.href,
      title = _ref7.title,
      onClick = _ref7.onClick,
      testId = _ref7.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    onClick: onClick,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "linkedin",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialLinkedIn.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  testId: PropTypes.string
};

function Header(_ref8) {
  var children = _ref8.children,
      testId = _ref8.testId;
  return ___EmotionJSX(Container, {
    bg: "primary.blue.t100",
    testId: testId
  }, ___EmotionJSX(Container, {
    bg: "primary.blue.t100",
    hasBreakpointWidth: true
  }, ___EmotionJSX(Flex, {
    direction: "column",
    "direction-sm": "row",
    placeItems: "left center"
  }, children)));
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
var SECTION_TITLES_AS = ["h2", "h3", "h4", "h5", "h6"];
var LINKS_DEFAULT_PROPS = {
  sectionTitlesAs: "h5",
  switchLayoutAt: "md"
};
Links.SECTION_TITLES_AS = SECTION_TITLES_AS;
Links.DEFAULT_PROPS = LINKS_DEFAULT_PROPS;

var _ref9 = process.env.NODE_ENV === "production" ? {
  name: "gg4vpm",
  styles: "display:flex;justify-content:space-between;"
} : {
  name: "gg4vpm",
  styles: "display:flex;justify-content:space-between;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Links(props) {
  var mergedProps = mergeProps(props, LINKS_DEFAULT_PROPS);
  var sectionTitlesAs = mergedProps.sectionTitlesAs,
      switchLayoutAt = mergedProps.switchLayoutAt,
      children = mergedProps.children,
      testId = mergedProps.testId;
  var theme = useTheme();
  var bp = useBreakpoint();
  var result = compareBreakpoints(bp, switchLayoutAt, theme);
  var isColumnsLayout = result >= 0;
  return ___EmotionJSX(FooterLinksProvider, {
    value: {
      sectionTitlesAs: sectionTitlesAs
    }
  }, ___EmotionJSX(Container, {
    bg: isColumnsLayout ? "white" : "primary.blue.t100",
    padding: isColumnsLayout ? "8 0" : "8 0 0 0",
    testId: testId
  }, ___EmotionJSX(Container, {
    hasBreakpointWidth: true
  }, isColumnsLayout ? ___EmotionJSX("div", {
    css: _ref9
  }, children) : ___EmotionJSX(Accordion, {
    itemGap: "small"
  }, Children.map(children, function (child, index) {
    return ___EmotionJSX(Accordion.Item, {
      key: index
    }, ___EmotionJSX(Accordion.Item.Header, null, child.props.title), ___EmotionJSX(Accordion.Item.Content, null, ___EmotionJSX(Stack, {
      gap: "5"
    }, child.props.children)));
  })))));
}

Links.propTypes = {
  sectionTitlesAs: PropTypes.oneOf(SECTION_TITLES_AS),
  switchLayoutAt: PropTypes.string,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function LinksSection(_ref10) {
  var title = _ref10.title,
      children = _ref10.children,
      testId = _ref10.testId;

  var _useFooterLinks = useFooterLinks(),
      sectionTitlesAs = _useFooterLinks.sectionTitlesAs;

  return ___EmotionJSX("div", {
    "data-testid": testId
  }, ___EmotionJSX(Text, {
    as: sectionTitlesAs,
    textStyle: "subtitle2",
    margin: "0 0 4 0"
  }, ___EmotionJSX("strong", null, title)), ___EmotionJSX(Stack, {
    gap: "5"
  }, children));
}

LinksSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function LegalLinks(_ref11) {
  var children = _ref11.children,
      testId = _ref11.testId;
  return ___EmotionJSX(Container, {
    padding: "0 4",
    "padding-lg": "0",
    textAlign: "center"
  }, ___EmotionJSX(Stack, {
    direction: "horizontal",
    align: "center",
    gap: "3 4",
    testId: testId
  }, children));
}

LegalLinks.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function LegalCopy(_ref12) {
  var children = _ref12.children,
      testId = _ref12.testId;
  return ___EmotionJSX(Container, {
    textStyle: "legal",
    margin: "7 0 0 0",
    testId: testId
  }, children);
}

LegalCopy.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function Legal(_ref13) {
  var children = _ref13.children,
      testId = _ref13.testId;
  return ___EmotionJSX(Container, {
    bg: "secondary.lightBlue.t25",
    testId: testId
  }, ___EmotionJSX(Container, {
    hasBreakpointWidth: true,
    padding: "9 0",
    textAlign: "center"
  }, children));
}

Legal.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function Footer(_ref14) {
  var children = _ref14.children,
      testId = _ref14.testId;
  return ___EmotionJSX("footer", {
    "data-testid": testId
  }, children);
}

Footer.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
Footer.Header = Header;
Footer.Header.Logo = HeaderLogo;
Footer.Header.Social = HeaderSocial;
Footer.Header.Social.Facebook = SocialFacebook;
Footer.Header.Social.YouTube = SocialYouTube;
Footer.Header.Social.Twitter = SocialTwitter;
Footer.Header.Social.Instagram = SocialInstagram;
Footer.Header.Social.LinkedIn = SocialLinkedIn;
Footer.Links = Links;
Footer.Links.Section = LinksSection;
Footer.Legal = Legal;
Footer.Legal.Links = LegalLinks;
Footer.Legal.Copy = LegalCopy;
export default Footer;